import React from "react"

import { useApp } from "../../../hooks/useApp"

export const withSearchFormResults = Component => ({ name = "SearchFormResults", data, processSearch }) => {
  const { globalStateReducer } = useApp()
  const [, dispatch] = globalStateReducer

  const handleClick = () => {
    processSearch()
  }

  const handleSearchClose = () => {
    dispatch({
      type: "setActiveSearch",
      payload: false,
    })
  }

  Component.displayName = name
  return <Component handleClick={handleClick} handleSearchClose={handleSearchClose} items={data} />
}
